<template>
  <div>
    <v-data-table
      :headers="facturasHeaders"
      :items="filtered4.length > 0 ? filtered4 : solicitud_factoring"
      rows-per-page-text="Registro por página"
      no-data-text="No existen solicitudes"
      no-results-text="No existen solicitudes"
      :rows-per-page-items="[5, 10, 25, { text: 'Todos', value: -1 }]"
      v-resize="onResize"
      :class="{ mobile: isMobile }"
    >
      <template v-slot:headers="props">
        <tr v-if="!isMobile">
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : '',
            ]"
            @click="changeSort(header.value)"
          >
            <v-icon small>arrow_upward</v-icon>
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr v-if="!isMobile">
          <td class="text-xs-center">
            {{ props.item.id }}
          </td>
          <td class="text-xs-center">
            {{ props.item.created_at | moment("DD-MM-YYYY") }}
          </td>
          <!-- <td class="text-xs-center">-</td> -->
          <td class="text-xs-center">
            {{ props.item.total_facturas | currency }}
          </td>
          <td class="text-xs-center">{{ props.item.cantidad_facturas }}</td>
          
          <td class="text-xs-center">
            {{ props.item.total_retenido | currency }}
          </td>
          <td class="text-xs-center">
            {{ props.item.descuento | currency }}
          </td>
          <td class="text-xs-center">
            {{ (props.item.descuento_terceros + props.item.gastos_confecamara +
                props.item.gastos_garantia + props.item.gastos_megag) | currency }}
          </td>
          <td class="text-xs-center">
            {{ props.item.monto_girar | currency }}
          </td>
          <td>
            <div v-if="props.item.detalle_cotizacion[0].factura_subida.tipo_marca == 1">
              Factoring
            </div>
            <div v-if="props.item.detalle_cotizacion[0].factura_subida.tipo_marca == 2">
              Pronto pago
            </div>
            <div v-if="props.item.detalle_cotizacion[0].factura_subida.tipo_marca == 3">
              Confirming
            </div>
          </td>
          <td class="text-xs-center">
            {{ props.item.estado_cot.descripcion }}
          </td>
          <td class="text-xs-center">
            <v-btn small
              style="border-radius: 25px; "
              class="rc-chip__ceder text-capitalize"
              @click="verDetalleCotizacion(props.item.id, props.item.detalle_cotizacion[0].factura_subida.tipo_marca)"
            >
              ver
            </v-btn>
            <v-btn 
              style="border-radius: 25px;" 
              small 
              class="rc-chip__ceder text-capitalize" 
              v-if="puedeAprobar" 
              @click="aprobarSolicitud(props.item.id)"
              >Gestionar</v-btn>
            <v-btn 
              style="border-radius: 25px;" 
              small 
              class="rc-chip__ceder text-capitalize" 
              v-if="puedeReenviar" 
              @click="openResimularOp(props.item.id)"
              >Resimular</v-btn>
          </td>
        </tr>
        <tr v-else class="rc-table__tr">
          <td>
            <ul class="flex-content" style="padding: 10px">
              <li class="flex-item" style="text-align: left" data-label="ID">
                <div style="font-weight: 600">
                  {{ props.item.id }}
                </div>
              </li>
              <li
                class="flex-item"
                style="text-align: left"
                data-label="Fecha Solicitud"
              >
                <div style="font-weight: 600">
                  {{ props.item.created_at | moment("DD-MM-YYYY") }}
                </div>
              </li>
              <li class="flex-item" style="text-align: left" data-label="Monto">
                <div style="font-weight: 600">
                  {{ props.item.total_facturas | currency }}
                </div>
              </li>
              <li
                class="flex-item"
                style="text-align: left"
                data-label="Cantidad de documentos"
              >
                <div style="font-weight: 600">
                  {{ props.item.cantidad_facturas }}
                </div>
              </li>
              <li
                class="flex-item"
                style="text-align: left"
                data-label="Monto retenido"
              >
                <div style="font-weight: 600">
                  {{ props.item.total_retenido | currency }}
                </div>
              </li>
              <li
                class="flex-item"
                style="text-align: left"
                data-label="Descuento"
              >
                <div style="font-weight: 600">
                  {{ props.item.descuento | currency }}
                </div>
              </li>
              <li>          
              <td class="text-xs-center">
                {{ (props.item.gastos_generales) | currency }}
              </td>
              </li>
              <li
                class="flex-item"
                style="text-align: left"
                data-label="Monto a recibir"
              >
                <div style="font-weight: 600">
                  {{ props.item.monto_girar | currency }}
                </div>
              </li>
              <li class="flex-item"
                style="text-align: left"
                data-label="Tipo">
                <div style="font-weight: 600" v-if="props.item.detalle_cotizacion[0].factura_subida.tipo_marca == 1">
                  Factoring
                </div>
                <div style="font-weight: 600" v-if="props.item.detalle_cotizacion[0].factura_subida.tipo_marca == 2">
                  Pronto pago
                </div>
                <div style="font-weight: 600" v-if="props.item.detalle_cotizacion[0].factura_subida.tipo_marca == 3">
                  Confirming
                </div>
              </li>
              <li
                class="flex-item"
                style="text-align: left"
                data-label="Estado"
              >
                <div style="font-weight: 600">
                  {{ props.item.estado_cot.descripcion }}
                </div>
              </li>
              <li
                class="flex-item"
                style="text-align: left"
                data-label="Seleccionar"
              >
                <v-btn
                 style="border-radius: 25px; "
                small
                  class="rc-chip__ceder text-capitalize"
                  @click="verDetalleCotizacion(props.item.id, props.item.detalle_cotizacion[0].factura_subida.tipo_marca)"
                >
                  ver
                </v-btn>
                <v-btn 
                  style="border-radius: 25px;" 
                  small 
                  class="rc-chip__ceder text-capitalize" 
                  v-if="puedeAprobar" 
                  @click="aprobarSolicitud(props.item.id)"
                  >Gestionar</v-btn>
                <v-btn 
                  style="border-radius: 25px;" 
                  small 
                  class="rc-chip__ceder text-capitalize" 
                  v-if="puedeReenviar" 
                  @click="openResimularOp(props.item.id)"
                  >Resimular</v-btn>
              </li>
            </ul>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogCotizacionDetalle"
      persistent
      transition="dialog-bottom-transition"
      width="95vw"
      scrollable
    >
      <v-card class="dialog-card" style="border-radius: 25px; padding-bottom: 40px;">
        <!-- Header -->
        <v-toolbar flat dark style="background-color: #F5F5F5 !important; color: #3d3d3d !important">
          <v-toolbar-title>Detalle solicitud</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            style="border: 1px solid #19B2A3; border-radius: 30px; color: #19B2A3; font-weight: 600; text-transform: none;"
            dark
            flat
            @click="dialogCotizacionDetalle = false"
          >
            Cerrar
          </v-btn>
        </v-toolbar>

        <!-- Tabla resumen -->
        <v-container>
          <v-layout justify-center>
            <v-flex xs12 md8 >
              <table class="table-new elevation-3 mt-3" style="margin: auto;" width="100%" cellspacing="0">
                <tr>
                  <th style="border-radius: 31px 0px 0px 0px; text-align: left; padding: 10px 15px;">TOTAL:</th>
                  <th style="border-radius: 0px 31px 0px 0px;"></th>
                </tr>
                <tr><td>Monto total de tus facturas</td><td>{{ resumen.total_facturas | currency }}</td></tr>
                <tr><td>Monto retenido</td><td>{{ resumen.total_retenido | currency }}</td></tr>
                <tr><td>Monto a financiar</td><td>{{ resumen.total_anticipo_bruto | currency }}</td></tr>
                <tr><td>Descuento</td><td>{{ resumen.descuento | currency }}</td></tr>
                <tr><td>Descuentos Adicionales</td><td>{{ resumen.gastos_generales | currency }}</td></tr>
                <tr><td>Gastos de operación</td><td>{{ resumen.total_gastos_notariales | currency }}</td></tr>
                <tr><td>Nº total de documentos</td><td>{{ resumen.detalle_cotizacion }}</td></tr>
                <tr><td>Monto a recibir</td><td>{{ (resumen.monto_girar - resumen.gastos_generales) | currency }}</td></tr>
              </table>
            </v-flex>
          </v-layout>
        </v-container>

        
        <!-- Tabs con scroll horizontal -->
        <v-container fluid>
          <v-layout justify-end>
            <v-flex xs12 class="text-xs-right">
              <div class="dropdown-wrapper">
                <v-btn
                  flat
                  class="newbtn__panel text-capitalize"
                  @click="menuOpen = !menuOpen"
                  ref="menuBtn"
                >
                  <v-icon class="mr-2">system_update_alt</v-icon>
                  Descargar
                </v-btn>

                <div
                  v-show="menuOpen"
                  ref="menu"
                  class="dropdown-content elevation-5"
                  v-click-outside="() => (menuOpen = false)"
                >
                  <template v-if="active3 == '0'">
                    <div class="dropdown-item" @click="exportDataExcel(columnNamesDeudores, deudores_group_export, 'deudores')">
                      <v-icon class="mr-2">description</v-icon> Excel
                    </div>
                    <div class="dropdown-item" @click="exportPDF('operaciones_deudor', 'deudores')">
                      <v-icon class="mr-2">description</v-icon> PDF
                    </div>
                  </template>

                  <template v-if="active3 == '1'">
                    <div
                      class="dropdown-item"
                      @click="exportDataExcel(
                        openTipoCotizacion == 1
                          ? columnNamesOpFactoring
                          : columnNamesOpConfirming,
                        detalle_cotizacion_export,
                        'operaciones'
                      )"
                    >
                      <v-icon class="mr-2">description</v-icon> Excel
                    </div>
                    <div class="dropdown-item" @click="exportPDF('operaciones_doc', 'detalle_cotizacion')">
                      <v-icon class="mr-2">description</v-icon> PDF
                    </div>
                  </template>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <div class="overflow-container">

          <Tabs
            v-model="active3"
            :value="0"
            :navAuto="false"
            :noTouch="true"
            :navSlider="true"
            class="holasoytab rc-tabsItems mb-3"
            id="pestana"
          >
            <!-- Tab Deudor -->
            <TabItem ref="tabItem1" name="Deudor" class="rc-tabName">
              <div class="overflow-container">
                <div class="scrollable">
                  <table class="table-new elevation-0" cellspacing="0">
                    <tr>
                      <th>ID</th>
                      <th>Razón social</th>
                      <th>Documentos</th>
                      <th>Mayor vencimiento facturas</th>
                      <th>Menor vencimiento facturas</th>
                      <th>Días promedio</th>
                      <th>Monto a financiar</th>
                      <th>Monto retenido</th>
                      <th>Porcentaje de descuento</th>
                      <th>Descuento</th>
                      <th>Monto a recibir</th>
                    </tr>
                    <tr v-for="(detalle, index) in deudores_group" :key="index">
                      <td>{{ index + 1 }}</td>
                      <!-- <td>{{ detalle.nit_deudor }}</td> -->
                      <td>{{ detalle.razon_social }}</td>
                      <td>{{ detalle.total_documento }}</td>
                      <td>{{ detalle.fecha_max }}</td>
                      <td>{{ detalle.fecha_min }}</td>
                      <td>{{ detalle.dias_prom }}</td>
                      <td>{{ detalle.monto_financiar | currency }}</td>
                      <td>{{ detalle.monto_retenido | currency }}</td>
                      <td>{{ detalle.tasa_deudor.toFixed(2) }} %</td>
                      <td>{{ detalle.descuento | currency }}</td>
                      <td>{{ detalle.monto_final_adelantado | currency }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </TabItem>

            <!-- Tab Documento -->
            <TabItem ref="tabItem2" name="Documento" class="rc-tabName">
              <div class="overflow-container">
                <div class="scrollable">
                  <table class="table-new elevation-0" cellspacing="0">
                    <tr>
                      <th>ID</th>
                      <th>Número factura</th>
                      <th>NIT pagador</th>
                      <th>Razón social pagador</th>
                      <th>NIT emisor</th>
                      <th>Razón social emisor</th>
                      <th>Monto facturas</th>
                      <th>Fecha de emisión facturas</th>
                      <th>Fecha de vencimiento facturas</th>
                      <th v-if="openTipoCotizacion == 1">Fecha de vencimiento operación</th>
                      <th>Fecha de negociación</th>
                      <th>Monto retenido</th>
                      <th>Monto a financiar</th>
                      <th>Descuento</th>
                      <th>Descuento Gastos</th>
                      <th>Monto a recibir</th>
                      <th>% de descuento</th>
                      <th>Tasa</th>
                      <th v-if="openTipoCotizacion == 1">Días</th>
                    </tr>
  
                    <tr
                      v-for="detalle in verdetalles.detalle_cotizacion"
                      :key="detalle.id"
                    >
                      <td>{{ detalle.id }}</td>
                      <td>{{ detalle.factura_subida.numero_factura }}</td>
                      <td>{{ detalle.factura_subida.deudor.nit }}</td>
                      <td>{{ detalle.factura_subida.deudor.razon_social }}</td>
                      <td>{{ detalle.factura_subida.empresa.nit }}</td>
                      <td>{{ detalle.factura_subida.empresa.razon_social }}</td>
                      <td>
                        {{ Math.round(detalle.factura_subida.monto) | currency}}
                      </td>
                      <td>{{ detalle.factura_subida.fecha_emision | moment("DD-MM-YYYY")}}</td>
                      <td>{{ detalle.factura_subida.fecha_vencimiento | moment("DD-MM-YYYY")}}</td>
                      <td v-if="openTipoCotizacion == 1">{{ detalle.fecha_extendida | moment("DD-MM-YYYY")}}</td>
                      <td>{{ detalle.fecha_negociacion | moment("DD-MM-YYYY")}}</td>
                      <td>{{ Math.round(detalle.monto_retenido) | currency }}</td>
                      <td>{{ Math.round(detalle.monto_financiar) | currency }}</td>
                      <td>{{ Math.round(detalle.descuento) | currency }}</td>
                      <td>{{ Math.round((detalle.descuento_confecamara + detalle.descuento_gastos_garantia + 
                              detalle.descuento_gravamen + detalle.descuento_megag)) | currency }}</td>
                      <td>{{Math.round(detalle.monto_final_adelantado) | currency}}</td>
                      <td>
                        {{
                          detalle.factura_subida && detalle.factura_subida.monto
                          ? ((detalle.descuento / detalle.factura_subida.monto) * 100).toFixed(2) + ' %'
                          : '-'
                        }}
                      </td>
                      <td>{{ (verdetalles.tasa_unica_fondo && verdetalles.tasa_unica_fondo !== '' && verdetalles.tasa_unica_fondo !== null) ? parseFloat(verdetalles.tasa_unica_fondo).toFixed(2) + ' %' : ((detalle.tasa_unica_fondo && detalle.tasa_unica_fondo !== '' && detalle.tasa_unica_fondo !== null) ? parseFloat(detalle.tasa_unica_fondo).toFixed(2) + ' %' : '0.00 %') }}</td>
                      <td v-if="openTipoCotizacion == 1">{{ detalle.plazo_total_pagador }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </TabItem>
          </Tabs>
          </div>  
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="gestionarCotizacion"
      width="460" 
      persistent
    >
      <v-card class="text-xs-center" style="position: relative;">
        <v-btn icon class="btnclose" @click="gestionarCotizacion = false"><v-icon>close</v-icon></v-btn>
        <v-container>
          <v-layout row wrap>
            <v-flex xs12 class="pa-1 text-xs-left">
              <h2 class="font-weight-bold pa-2">Gestionar cotización</h2>
            </v-flex>
            <v-flex xs12 class="pa-3">
                <v-layout class="text-xs-left py-2" row wrap justify-space-between>
                    <v-flex xs12 md6 class="text-xs-left">ID Cotización</v-flex>
                    <v-flex xs12 md6 class="text-xs-right"><strong>{{ handleCot.cot_id === null ? '-' : handleCot.cot_id}}</strong></v-flex>
                </v-layout>
            </v-flex>

              <v-flex xs12 class="pa-3 text-xs-left">
              <div class="text-xs-left"><strong>Selecciona una opción</strong></div>
               <v-select
                  :items="estados"
                  item-text="descripcion"
                  item-value="id"
                  v-model="handleCot.selectedState"
                  label="Selecciona una opción"
                  outline
                  class="rc-dense-select mt-2 border-text"
                  style="display: inline-flex !important; width: 400px !important;"
                  :rules="[(v) => !!v || 'Debes seleccionar una opción']"
                >
                  <template v-slot:item="data">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <span
                          :class="{
                            'badge badge_green': data.item.id === 1,
                            'badge badge_red': data.item.id === 2
                          }"
                        >
                          {{ data.item.descripcion }}
                        </span>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                  <template v-slot:selection="data">
                    <span
                      :class="{
                        'badge badge_green': data.item.id === 1,
                        'badge badge_red': data.item.id === 2
                      }"
                    >
                      {{ data.item.descripcion }}
                    </span>
                  </template>
                </v-select>

              </v-flex>
            <v-flex xs12 class="pa-2 text-xs-right">
                <v-btn
                color="primary"
                class="rc-button_prim rc-btn_s"
                style="text-transform:initial"
                :disabled="isConfirmDisabled"
                @click="updStateCot"
              >
                Confirmar
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="resimularOp.modal" persistent width="460">
      <v-card class="text-xs-center" style="position: relative;">
          <v-container>
              <v-layout row wrap>
                  <v-flex xs12 class="pa-1 text-xs-center">
                    <v-img
                      src="/images/iris/sync.png"
                      style="width:80px;margin:auto;"
                    ></v-img>
                    <h1 class="cmodal font-weight-bold pa-2">Resimular operación</h1>
                  </v-flex>
                  <v-flex xs12 class="py-2 px-4">
                      <v-layout class=" cmodaltext-xs-center" row wrap justify-space-between d-flex>
                          <p class="">
                              Se volverá a simular la operación y quedará pendiente de aprobación.
                          </p> 
                      </v-layout>
                  </v-flex>
                  <v-flex xs12 class="py-2">
                      <v-layout row wrap justify-center>
                        <v-flex xs12 md6>
                          <v-btn 
                              flat 
                              class="rc-button_scol"
                              @click="resimularOp.modal = false"
                          >
                              Cancelar
                          </v-btn>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-btn 
                              flat 
                              class="rc-button_prim ml-2"
                              @click="resimularOperacion"
                          >
                              Resimular
                          </v-btn>
                        </v-flex>
                      </v-layout>
                  </v-flex>
              </v-layout>
          </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="expiredOp" persistent width="450">
        <v-card>
            <v-container class="rc-creditos__modal">
                <v-layout row wrap>
                    <v-flex xs12 class="pa-1 text-xs-center">
                    <v-img
                      src="/images/iris/Error.png"
                      style="width:80px;margin:auto;"
                    ></v-img>
                    <h1 class="cmodal font-weight-bold pa-2">No es posible actualizar la cotización</h1>
                  </v-flex>
                  <v-flex xs12 class="py-2 px-4">
                      <v-layout class="cmodal text-xs-center" row wrap justify-space-between d-flex>
                          <p>
                            Debes resimular la operación. Puedes hacerlo en Solicitudes expiradas.
                          </p> 
                      </v-layout>
                  </v-flex>
                  <v-flex xs12 class="py-2">
                      <v-layout row wrap justify-center>
                        <v-flex xs12 md6>
                          <v-btn 
                              flat 
                              class="rc-button_prim"
                              @click="handleNoticeAccept"
                          >
                              Aceptar
                          </v-btn>
                        </v-flex>
                      </v-layout>
                  </v-flex>
                </v-layout>
            </v-container>
        </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import { mapState } from "vuex";
import API from "@/api";
var moment = require("moment");
import { EventBus } from "@/main";
// @ts-ignore
import JsonExcel from "vue-json-excel";
// @ts-ignore
import { Tabs, TabItem } from "vue-material-tabs";
import * as XLSX from 'xlsx';
import { generatePDF } from "@/utils";

Vue.component("downloadExcel", JsonExcel);
@Component({
  computed: {
    ...mapState(["user"]),
    filtered4() {
      return this.$data.solicitud_factoring.filter((i) => {
        return (
          this.$data.documento_sol_factoring.includes(i.cantidad_facturas) ||
          this.$data.date_solicitud_sol_factoring.includes(
            moment(i.created_at).format("DD-MM-YYYY")
          ) ||
          this.$data.state_sol_factoring.includes(i.estado_cot.descripcion)
        );
      });
    },
    puedeAprobar() {
      return this.mode === 'pendientes' && (this.role == 1 || this.role == 2);
    },
    puedeReenviar() {
      return this.mode === 'expiradas' && (this.role == 1 || this.role == 2);
    },
    isConfirmDisabled() {
      const estadoSeleccionado = this.handleCot.selectedState;

      const estadoValido = this.estados.some(e => e.id === estadoSeleccionado);

      return !estadoValido;
    }

  },
  data() {
    return {
      solicitud_factoring: [],
      documento_sol_factoring: "",
      date_solicitud_sol_factoring: "",
      state_sol_factoring: "",
      resumen: {
        total_anticipo_bruto: "",
        total_gastos_notariales: "",
        descuento: "",
        monto_girar: "",
        total_retenido: "",
        total_facturas: "",
        detalle_cotizacion: "",
        gastos_generales: "",
        tasa_unica_fondo: ""
      },
      verdetalles: {
        detalle_cotizacion: [],
      },
      dialogCotizacionDetalle: false,
      isMobile: false,
      active3: 0,
      columnNamesOpFactoring:{
        num_factura: 'N° de factura',
        nit_deudor: 'NIT pagador',
        nombre_deudor: 'Nombre pagador',
        nit_emisor: 'NIT emisor',
        nombre_emisor: 'Nombre emisor',
        monto: 'Monto facturas',
        fecha_emision: 'Fecha emisión factura',
        fecha_vencimiento: 'Fecha vencimiento factura',
        fecha_extendida: 'Fecha vencimiento operación',
        fecha_operacion: 'Fecha negociación',
        descuento: 'Descuento factoring',
        monto_retenido: 'Monto retenido',
        monto_financiar: 'Monto a financiar',
        valor_tasa: '% de descuento',
        tasa_unica_fondo: 'Tasa',
        monto_final_adelantado: 'Monto a recibir',
        plazo_factura: 'Dias',
      },
      columnNamesOpConfirming:{
        num_factura: 'N° de factura',
        nit_deudor: 'NIT pagador',
        nombre_deudor: 'Nombre pagador',
        nit_emisor: 'NIT emisor',
        nombre_emisor: 'Nombre emisor',
        monto: 'Monto',
        fecha_emision: 'Fecha emisión factura',
        fecha_vencimiento: 'Fecha vencimiento factura',
        fecha_operacion: 'Fecha negociación',
        descuento: 'Descuento',
        monto_retenido: 'Monto retenido',
        monto_financiar: 'Monto a financiar',
        valor_tasa: '% de descuento',
        tasa_unica_fondo: 'Tasa',
        monto_final_adelantado: 'Monto a recibir',
      },
      columnNamesDeudores:{
        nit_deudor: 'NIT pagador',
        nombre_deudor: 'Nombre pagador',
        monto_acumulado: 'Monto acumulado',
        documentos: 'Documentos',
        mayor_vencimiento: 'Mayor vencimiento',
        menor_vencimiento: 'Menor vencimiento',
        dias_promedio: 'Dias promedio',
        monto_financiar: 'Monto financiar',
        monto_retenido: 'Monto retenido',
        monto_final_adelantado: 'Monto a recibir',
        descuento: 'Descuento',
        tasa: 'Porcentaje de descuento'
      },
      openTipoCotizacion: 0,
      deudores_group: [],
      deudores_group_export: [],
      detalle_cotizacion_export: [],
      pagination: {
        sortBy: "factura_id",
      },
      facturasHeaders: [
        { text: "ID", align: "center" },
        { text: "Fecha Solicitud", align: "center" },
        { text: "Monto", align: "center" },
        { text: "Cantidad de Documento", align: "center" },
        { text: "Monto retenido", align: "center" },
        { text: "Descuento", align: "center" },
        { text: "Descuentos Adicionales", align: "center" },
        { text: "Montos a recibir", align: "center" },
        { text: "Tipo", align: "center" },
        { text: "Estado", align: "center" },
        { text: "Seleccionar", align: "center", sortable: false },
      ],
      gestionarCotizacion: false,
      estados: [
        {
          id: 1,
          descripcion: "Aprobado"
        },
        {
          id: 2,
          descripcion: "Rechazo"
        }
      ],
      handleCot: {
        cot_id: null, 
        selectedState: null, 
      }, 
      resimularOp: {
        modal: false,
        op_id: null,
      },
      expiredOp: false,
      menuOpen: false,
    };
  },
  watch: {
    data: {
      handler(newVal) {
        if (Array.isArray(newVal) && newVal.length > 0) {
          this.solicitud_factoring = newVal;
          this.emitirFiltros();
        }else{
          this.solicitud_factoring = [];
          this.emitirFiltros();
        }
      },
      immediate: true,
    },
    doc(val) {
      this.documento_sol_factoring = val;
    },
    fv(val) {
      this.date_solicitud_sol_factoring = val;
    },
    estado(val) {
      this.state_sol_factoring = val;
    },
  },
  methods: {
    emitirFiltros() {
      const moment = require("moment");
      this.$emit("documentoSolFactoring", this.solicitud_factoring.map(i => i.cantidad_facturas).filter(Boolean));
      this.$emit("solicitudFactoring", this.solicitud_factoring.map(i => moment(i.created_at).format("DD-MM-YYYY")).filter(Boolean));
      this.$emit("estadoSolFactoring", this.solicitud_factoring.map(i => i.estado_cot.descripcion).filter(Boolean));
    },
    async verDetalleCotizacion(id, tipo_cotizacion) {
      this.$data.verdetalles = [];
      this.$data.deudores_group = [];
      this.$data.openTipoCotizacion = tipo_cotizacion;
      this.$data.verdetalles = await API.solicitud_factoringVerDetalle(
        id,
        this.$props.empresa_id
      );
      // Buscar tasa_unica_fondo en diferentes niveles de la respuesta
      let tasaUnicaFondo = this.$data.verdetalles.tasa_unica_fondo;
      
      // Si no está en el nivel superior, buscar en el primer detalle
      if (!tasaUnicaFondo && this.$data.verdetalles.detalle_cotizacion && this.$data.verdetalles.detalle_cotizacion.length > 0) {
        tasaUnicaFondo = this.$data.verdetalles.detalle_cotizacion[0].tasa_unica_fondo;
      }
      
      // Si aún no está, buscar en data.data (estructura anidada)
      if (!tasaUnicaFondo && this.$data.verdetalles.data) {
        tasaUnicaFondo = this.$data.verdetalles.data.tasa_unica_fondo;
      }
      
      console.log('tasaUnicaFondo encontrado:', tasaUnicaFondo);
      console.log('tipo:', typeof tasaUnicaFondo);
      
      this.$data.resumen = {
        total_anticipo_bruto: this.$data.verdetalles.total_anticipo_bruto,
        total_gastos_notariales: this.$data.verdetalles.total_gastos_notariales,
        descuento: this.$data.verdetalles.descuento,
        monto_girar: this.$data.verdetalles.monto_girar,
        total_retenido: this.$data.verdetalles.total_retenido,
        total_facturas: this.$data.verdetalles.total_facturas,
        detalle_cotizacion: this.$data.verdetalles.detalle_cotizacion.length,
        gastos_generales: this.$data.verdetalles.gastos_generales,
        tasa_unica_fondo: tasaUnicaFondo,
      };

      this.$data.detalle_cotizacion_export =
        this.$data.verdetalles.detalle_cotizacion.map((i) => {
          return {
            cotizacion_id: i.id,
            num_factura: i.factura_subida.numero_factura,
            nit_deudor: i.factura_subida.deudor.nit,
            nombre_deudor: i.factura_subida.deudor.razon_social,
            nit_emisor: i.factura_subida.empresa.nit,
            nombre_emisor: i.factura_subida.empresa.nombre,
            // @ts-ignore
            monto: this.$options.filters.currency(Math.round(i.factura_subida.monto)),
            fecha_emision: moment(i.factura_subida.fecha_emision).format("DD/MM/YYYY"),
            fecha_vencimiento: moment(i.factura_subida.fecha_vencimiento).format("DD/MM/YYYY"),
            fecha_extendida: moment(i.fecha_extendida).format("DD/MM/YYYY"),
            fecha_operacion: moment(i.fecha_negociacion).format("DD/MM/YYYY"),
            //@ts-ignore
            monto_retenido: this.$options.filters.currency(Math.round(i.monto_retenido)),
            // @ts-ignore
            monto_financiar: this.$options.filters.currency(Math.round(i.monto_financiar)),
            //@ts-ignore
            tasa: i.interes,
            valor_tasa: i.factura_subida && i.factura_subida.monto
              ? `${((i.descuento / i.factura_subida.monto) * 100).toFixed(2)} %`
              : '-',
            //@ts-ignore
            tasa_unica_fondo: parseFloat(this.$data.verdetalles.tasa_unica_fondo || i.tasa_unica_fondo || 0).toFixed(2) + ' %',
            //@ts-ignore
            monto_final_adelantado: this.$options.filters.currency(Math.round(i.monto_final_adelantado)),
            dias_separacion: i.dias_separacion,
            plazo_factura: i.plazo_total_pagador,
            //@ts-ignore
            descuento: this.$options.filters.currency(Math.round(i.descuento)),
            gastos_generales: this.$options.filters.currency(Math.round(i.gastos_generales)),
            fecha_linea_triangular: moment(i.fecha_linea_triangular, "YYYY-MM-DD", true).isValid() 
                                    ? moment(i.fecha_linea_triangular).format("DD/MM/YYYY") 
                                    : '',
            //@ts-ignore
            monto_linea_triangular: !isNaN(i.monto_linea_triangular) && i.monto_linea_triangular != null 
            //@ts-ignore
                                    ? this.$options.filters.currency(Math.round(i.monto_linea_triangular)) 
                                    : '',
          };
        });

      var unique = [
        ...new Set(
          this.$data.verdetalles.detalle_cotizacion.map(
            (p) => p.factura_subida.deudor_id
          )
        ),
      ];
      var deudores = [];

      unique.forEach((element) => {
        deudores[element] = this.$data.verdetalles.detalle_cotizacion.filter(
          (x) => x.factura_subida.deudor_id == element
        );
      });

      deudores.map((el, key) => {
        var total_documentos = el.length;
        var fechas = [
          ...new Set(
            el.map((p) =>
              moment(p.factura_subida.fecha_vencimiento.trim())
            )
          ),
        ];
        var fecha_max = moment.max(fechas);
        var fecha_min = moment.min(fechas);
        var cantidad_dias = el.reduce(
          (acc, el) => acc + el.plazo_total_pagador,
          0
        );
        var dias_prom = Math.round(cantidad_dias / total_documentos);
        var monto = el.reduce(
          (acc, el) => acc + Math.round(el.factura_subida.monto),
          0
        );
        var monto_financiar = el.reduce(
          (acc, el) => acc + Math.round(el.factura_subida.monto),
          0
        );
        var monto_retenido = el.reduce(
          (acc, el) => acc + Math.round(el.monto_retenido),
          0
        );
        var descuento = el.reduce(
          (acc, el) => acc + Math.round(el.descuento),
          0
        );
        var monto_final_adelantado = el.reduce(
          (acc, el) => acc + Math.round(el.monto_final_adelantado),
          0
        );
        let tasa_deudor = el.reduce(
          (acc, el) => acc + ((Math.round(el.descuento) / (Math.round(el.factura_subida.monto))) * 100), 0)
        var obj_deudor = {
          fecha_max: fecha_max.format("DD-MM-YYYY"),
          fecha_min: fecha_min.format("DD-MM-YYYY"),
          cantidad_dias: cantidad_dias,
          dias_prom: dias_prom,
          monto: monto,
          monto_financiar: monto_financiar,
          monto_retenido: monto_retenido,
          descuento: descuento,
          monto_final_adelantado: monto_final_adelantado,
          rut_deudor: el[0].factura_subida.deudor.nit,
          razon_social: el[0].factura_subida.deudor.razon_social,
          nombre_deudor: el[0].factura_subida.deudor.nombre,
          total_documento: total_documentos,
          tasa_deudor: tasa_deudor
        };
        this.$data.deudores_group.push(obj_deudor);
      });
      this.$data.deudores_group_export = this.$data.deudores_group.map(
        (i) => {
          return {
            nit_deudor: i.rut_deudor,
            nombre_deudor: i.razon_social,
            //@ts-ignore
            monto_acumulado: this.$options.filters.currency(i.monto_retenido),
            documentos: i.total_documento,
            mayor_vencimiento: i.fecha_max,
            menor_vencimiento: i.fecha_min,
            dias_promedio: i.dias_prom,
            //@ts-ignore
            monto_financiar: this.$options.filters.currency(
              i.monto_financiar
            ),
            //@ts-ignore
            monto_retenido: this.$options.filters.currency(i.monto_retenido),
            tasa_descuento: "-",
            //@ts-ignore
            descuento: this.$options.filters.currency(i.descuento),
            //@ts-ignore
            monto_final_adelantado: this.$options.filters.currency(
              i.monto_final_adelantado
            ),
            tasa: `${(i.tasa_deudor).toFixed(2)} %`
          };
        }
      );
      this.$data.dialogCotizacionDetalle = true;
    },
    onResize() {
      if (window.innerWidth < 1263) this.$data.isMobile = true;
      else this.$data.isMobile = false;
    },
    exportDataExcel(columns, array_data, name_file){
        //@ts-ignore
        let dataToExport = XLSX.utils.json_to_sheet(this.filterDataToExport(columns, array_data));
        const workBook = XLSX.utils.book_new();
        //@ts-ignore
        const fileName = name_file;
        XLSX.utils.book_append_sheet(workBook, dataToExport, fileName);
        XLSX.writeFile(workBook, `${fileName}.xlsx`);
    },

    filterDataToExport(columnNames, array_data) {

        const columnsToExport = Object.keys(columnNames);
        //@ts-ignore
        return array_data.map(item => {
            const filteredItem = {};
            columnsToExport.forEach((column) => {
                //@ts-ignore
                filteredItem[columnNames[column]] = item[column];
            });

            return filteredItem;
        });
    },
    async exportPDF(type, name){
        try {
            const { id } = this.$data.verdetalles;
            const payload = {
              cotizacion_id: id,
              producto: this.$data.openTipoCotizacion,
              tasa_unica_fondo: this.$data.verdetalles.tasa_unica_fondo
            }
            //@ts-ignore
            await generatePDF(type, name, payload);
            EventBus.$emit("snack-success","Documento descargado exitosamente");
        } catch (error) {
            EventBus.$emit("snack-error","Error al descargar el PDF, intenta más tarde");
        }
    },
    aprobarSolicitud(cot_id){
      this.$data.handleCot.cot_id = cot_id;
      this.$data.gestionarCotizacion = true;
    },
    openResimularOp(cot_id){
      this.$data.resimularOp.modal = true;
      this.$data.resimularOp.op_id = cot_id;
    },
    async updStateCot(){
      const { cot_id, selectedState } = this.$data.handleCot; 

      if(!cot_id || this.isConfirmDisabled){
        EventBus.$emit("snack-error", "Error en los párametros enviados");
      }

      try {
        const payload = {
          cotizacion_id: cot_id,
          estado: selectedState,
        }

        const response = await API.cambiarEstadoCotizacion(payload);
        EventBus.$emit("snack-success", response.message || "Cotización actualizada.");
        this.$emit('changeTab', 0);
      } catch (error) {
        if(error.status === 419){
          this.$data.gestionarCotizacion = false;
          await this.showImportantNotice();
          this.$emit('changeTab', 2);
          return;
        }

        EventBus.$emit("snack-error", error.message || "No se pudo actualizar el estado.");
      }finally{
        this.$data.gestionarCotizacion = false;
      }

    },
    async resimularOperacion(){
      const { op_id } = this.$data.resimularOp; 

      if(!op_id){
        EventBus.$emit("snack-error", "Error en los párametros enviados");
      }

      try {
        const payload = {
          operacion_id: op_id,
        }

        const response = await API.resimularCotizacion(payload);
        this.$data.resimularOp.modal = false;
        EventBus.$emit("snack-success", response.msg || "Operación resimulada.");
        this.$emit('changeTab', 1);
      } catch (error) {
        if(error.status === 422){
          EventBus.$emit("snack-error", error.message);
          this.$data.resimularOp.modal = false;
          return;
        }

        EventBus.$emit("snack-error", error.message || "No se pudo actualizar la operación.");
      }
    },
    showImportantNotice() {
      this.$data.expiredOp = true;

      return new Promise((resolve) => {
          this._resolveNotice = resolve; 
      });
    },
    handleNoticeAccept() {
      this.$data.expiredOp = false;
      if (this._resolveNotice) {
          this._resolveNotice(); 
          this._resolveNotice = null;
      }
    },
    handleClickOutside(event) {
      const menu = this.$refs.menu;
      const btn = this.$refs.menuBtn && this.$refs.menuBtn.$el ? this.$refs.menuBtn.$el : this.$refs.menuBtn;

      if (!this.menuOpen) return;

      if (
        (menu && menu.contains(event.target)) ||
        (btn && btn.contains(event.target))
      ) {
        return;
      }

      this.menuOpen = false;
    }

    
  },
  mounted() {
    window.addEventListener("click", this.handleClickOutside, true);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.handleClickOutside, true);
  },
  components: {
    Tabs,
    TabItem,
  },
})
export default class tableResumen extends Vue {
  @Prop({ default: () => [] }) data;
  @Prop({ default: "" }) empresa_id;
  @Prop({ default: "" }) doc;
  @Prop({ default: "" }) fv;
  @Prop({ default: "" }) estado;
  @Prop({ default: "solicitudes"}) mode;
  @Prop({ default: ""}) role;

}
</script>
<style>
.dialog-card {
  max-height: 90vh;
  overflow-y: auto;
}

.overflow-container {
  width: 100%;
  max-height: 60vh;
  overflow-y: auto;
}
.scrollable {
  overflow-x: auto;
  width: 100%;
}
.table-new {
  width: 100%;
}

</style>

<style scoped>
.dropdown-wrapper {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  position: absolute;
  top: 90%;
  right: 0;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 160px;
  padding: 0.5rem 0;
}

.dropdown-item {
  padding: 10px 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s ease;
}

.dropdown-item:hover {
  background-color: #f4f4f4;
}
</style>
